/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const ItemsContainer = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  height: 400px;
  padding: 24px;
  background: ${Palette.PrimaryGray._000};
  ::-webkit-scrollbar {
    width: 6px;
    background-color: ${Palette.PrimaryGray._000};
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;

export const EmptyPage = styled.div`
  height: 400px;
  display: grid;
  place-items: center;
  color: ${Palette.PrimaryGray._700};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  background: ${Palette.PrimaryGray._000};
`;

export const CreativeItem = styled.div`
  display: flex;
  border: 1px solid ${Palette.PrimaryGray._000};
  height: 48px;
  gap: 16px;
  align-items: center;
  justify-content: start;
  padding: 8px;
  border-radius: 4px;

  cursor: pointer;
  svg {
    fill: #94a3b8;
  }
  :hover {
    background: ${Palette.PrimaryGray._100};
    svg {
      fill: #64748b;
    }
  }

  :active {
    border: 1px solid ${Palette.Primary._300};
    background: ${Palette.Primary._000};
    svg {
      fill: ${Palette.Primary._500};
    }
    /* p {
      color: ${Palette.PrimaryGray._900};
    } */
  }
  ${({ isSelected }) =>
    isSelected &&
    css`
      border: 1px solid ${Palette.Primary._300};
      background: ${Palette.Primary._000};
      svg {
        fill: ${Palette.Primary._500};
      }
      /* p {
        color: ${Palette.PrimaryGray._900};
      } */
    `}
`;

export const DateBox = styled.p`
  margin-left: auto;
  color: ${Palette.PrimaryGray._500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const SelectedCreative = styled.div``;
